module.exports = __webpack_public_path__ + "img/iconattraversamento.d2c5613b.svg";